import styled from "styled-components";
import { device } from "../../../themes/Breakpoints";


export const Wrapper = styled.section``;

export const MyEventWrap = styled.div`
  table {
    border-spacing: 0;
    width: 100%;
    border: 1px solid #004ea3;
    border-radius: 8px;
    border-bottom-right-radius: 0px;
    thead {
      border-radius: 8px;
      th {
        border-bottom: 1px solid #004ea3;
      }
      tr {
        th {
          :first-child {
            border-top-left-radius: 8px;
          }
          :last-child {
            border-top-right-radius: 8px;
          }
        }
      }
    }
    tbody {
      td {
        border-bottom: 1px solid #004ea3;

        text-align: center;
      }
      tr:last-child {
        td {
          :first-child {
            border-bottom-left-radius: 8px;
          }
          :last-child {
            border-bottom-right-radius: 8px;
          }
        }
      }
    }
    tr {
      background-color: var(--color-gray);
      border-radius: 8px;
      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }

    th,
    td {
      margin: 0;
      padding: 16px 64px 16px 24px;
      border-right: 1px solid #004ea3;
      :last-child {
        border-right: 0;
      }
    }
  }

  @media only screen and (max-width: 1249px) {
    table {
      th,
      td {
        padding: 10px;
    }
  }
`;

export const ViewWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  .list {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .list-name {
    display: flex;
    align-items: center;
    gap: 10px;
    a {
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      color: #107c41;
      font-family: "Saira Semi Condensed", sans-serif;
      cursor: pointer;
    }
  }
`;

export const SelectEventContainer= styled.div`
    display: flex;
    justify-content: space-between;
    > button{
        padding: 8px 12px;
        border-radius: 4px;
        background: #1C4F9E;
        color: #FFF;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        cursor: pointer;
    }
`;

    export const SelectEvent = styled.div`
  display: flex;
  align-items: center;
  button {
     display: block;
      padding: 10px 16px;
      font-size: 18px;
    font-weight: 600;
    line-height: 24px;
    font-family: "Saira Semi Condensed", sans-serif;
    color: #0e1118;
    transition: all 0.3s linear;
    cursor: pointer;
      margin-bottom: 20px;
    &.active {
        border-radius: 4px;
        border: 2px solid #2460C5;   
        color: #004ea3;
    }
    :hover {
        border-radius: 4px;
        border: 2px solid #2460C5;
        color: #004ea3;
    }
  }
`;

export const Container = styled.div`
  padding: 32px 0;
  @media only screen and (max-width: 768px) {
    padding: 24px 0px 8px
  }
`;

export const EventList = styled.div`
   display: flex;
    flex-direction: column;
    gap: 16px;
    height: 1000px;
    overflow:auto;
`;


export const SingleEvent=styled.div`
    padding: 16px;
    width: 100%;
    border: 1px solid rgba(0, 0, 0, 0.20);
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .col {
        flex: 1;             /* All columns equal width */
        text-align: left;
    }
    div{
        display: flex;
        flex-direction:column;
        align-items: center;
        font-family: "Saira Semi Condensed", sans-serif;
        &:last-of-type {
            h5, p {
                color: #1C4F9E;
            }
        }
    }
    h5{
        color: #000;
        text-align: center;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }
    p{
        color: #000;
        text-align: center;
        font-size: 12px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
    }
    button{
        padding: 8px 12px;
        font-size: 12px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        color: #FFF;
        border-radius: 4px;
        background: #1C4F9E;
        cursor: pointer;
    }
`;

//old

export const FormWrap = styled.form`
  width: 100%;
  max-width: 730px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 40px;
  flex-wrap: wrap;
  @media only screen and (max-width: 1249px) {
    gap:30px;
  }
`;

export const InputBlock = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 40px;
  flex-wrap: wrap;
  width: 100%;
  @media only screen and (max-width: 1249px) {
    gap:30px;
  }
`;

export const BtnWrap = styled.div`
  button[type="submit"] {
    background-color: #004ea3;
    color: #fff;
    font-size: 20px;
    font-weight: 600;
    line-height: 30px;
    border-radius: 4px;
    padding: 13px 32px;
    border: none;
    cursor: pointer;
    transition: all 0.3s linear;
    :hover {
      opacity: .9;
    }
  }
  @media only screen and (max-width: 1023px) {
    button[type="submit"] {
      padding: 13px 23px;
      font-size: 16px;
    }
  }
`;

export const InputContainer = styled.div`
  max-width: 345px;
  width: 100%;
  position: relative;
  font-family: "Saira Semi Condensed", sans-serif;
  label {
    display: block;
    font-weight: 400;
    font-size: 18px;
    line-height: 27px;
    margin-bottom: 4px;
  }
  h6 {
    font-size: 18px;
    line-height: 27px;
    font-weight: 400;
    margin-bottom: 12px;
  }
  .event-file {
    display: flex;
    align-items: center;
    gap: 20px;

    a,span {
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      color: #107c41;
      font-family: "Saira Semi Condensed", sans-serif;
      cursor: pointer;
    }
  }
  .event-info {
    a,span {
      color: #004ea3;
      text-decoration: underline;
      cursor: pointer;
    }
  }
  @media only screen and (max-width: 768px) {
    margin-bottom: 8px;
  }
`;

export const InputWrap = styled.input`
  outline: ${(props) => (props.error ? "1px solid red" : "1px solid #AFB4B9")};
  width: 100%;
  height: 42px;
  color: #0e1118;
  background-color: transparent;
  border-radius: 4px;
  padding: 11px 9px 11px 16px;
  border: none;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  ::placeholder {
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
  }
  input:invalid + span::after {
    content: "✖";
    max-width: 200px;
    padding-left: 5px;
  }

  input:valid + span::after {
    content: "✓";
    max-width: 200px;
    padding-left: 5px;
  }
`;

export const ErrorMessage = styled.div`
  color: red;
  opacity: ${(props) => (props.visible ? "1" : "0")};
  position: absolute;
  top: 110%;
`;

export const ErrorWrap = styled.div`
  position: relative;
  div {
    position: inherit;
    text-align: center;
    margin-bottom: 5px;
  }
`;

export const GenerateEventBlock = styled.div`
  position: relative;

  .generate {
    position: absolute;
    top: 8px;
    right: 11px;
    color: #004ea3;
    text-align: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    text-decoration-line: underline;
    cursor: pointer;
  }
  .icon {
    position: absolute;
    top: 8px;
    left: 11px;
  }
  & .event-id {
    padding-left: 35px;
    &::placeholder {
    }
  }
`;

export const ActionWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
  img {
    width: 25px;
    cursor: pointer;
  }
  @media only screen and (max-width: 1249px) {
    img {
      width: 18px;
    }
  }
`;

export const BackArrow = styled.div`
  cursor: pointer;
  svg path {
    color: #004ea3;
  }

`;

export const ViewItem = styled.div`
  max-width: 400px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  p {
    max-width: 200px;
    width: 100%;
    text-align: left;
  }
  p:has(span) {
    display: flex;
    align-items: center;
    gap: 5px;
  }
  div {
    display: flex;
    align-items: center;

  }
`;

export const ChooseSubs = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  h2 {
    font-size: 32px;
    font-style: normal;
    font-weight: 400;
    line-height: 41.6px;
    margin-bottom: 12px;
  }
  button {
    padding: 12px 32px;
    background: #004ea3;
    border-radius: 4px;
    font-weight: 600;
    font-size: 20px;
    line-height: 30px;
    color: #ffffff;
    display: block;
    margin: 0 auto;
    margin-top: 24px;
    cursor: pointer;
  }
  @media only screen and (max-width: 768px) {
    padding: 13px;
    font-size: 16px;
    line-height: 24px;
  }
`;

export const HowImport = styled.div`
  position: relative;
  background-color: #fff;
  border-radius: 10px;
  background: #fff;
  padding: 0 48px;
  .modal-body {
    padding-top: 60px;
    max-width: 900px;
    width: 100%;
    text-align: center;
  }
  .modal-info {
    max-width: 700px;
    margin: 0 auto;
    width: 100%;
  }
  .excel {
    img {
      max-width: 900px;
      width: 100%;
      display: block;
      object-fit: cover;
      height: auto;
    }
  }
  .close {
    position: absolute;
    top: 2%;
    right: 3%;
    cursor: pointer;
    img {
      width: 100%;
      max-width: 40px;
      height: auto;
      display: block;
      object-fit: cover;
    }
  }
  h4 {
    color: #0e1118;
    text-align: center;
    font-size: 38px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
  p {
    color: rgba(14, 17, 24, 0.8);
    text-align: center;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px;
  }
  @media only screen and (max-width: 768px) {
    padding: 0 12px;
  }
  @media ${device.tablet} {
    .modal-body {
      padding-top: 45px;
      .modal-info {
        h4 {
          font-size: 32px;
          margin-bottom: 12px;
        }
      }
    }
  }
  @media ${device.mobileL}{
    .modal-body {
      padding-top: 45px;
      .modal-info {
        h4 {
          font-size: 30px;
          line-height: 40px;
          margin-bottom: 12px;
        }
        p {
          font-size: 18px;
        }
      }
    }
    .close {
      max-width: 30px;
    }
  }
  @media ${device.mobileM} {
    .modal-body {
      padding-top: 45px;
      .modal-info {
        h4 {
          font-size: 26px;
          line-height: 32px;
          margin-bottom: 12px;
        }
        p {
          font-size: 18px;
          margin-bottom: 12px;
        }
      }
    }
    .close {
      max-width: 30px;
    }
  }
  @media ${device.mobileS} {
    .modal-body {
      padding-top: 45px;
      .modal-info{
        h4{
          font-size: 26px;
          line-height: 32px;
        }
        p {
          font-size: 18px;
        }
      }
    }
    .close {
        max-width: 30px;
    }
  }
`;



// import styled from "styled-components";
// import { device } from "../../../themes/Breakpoints";
//
//
// export const Wrapper = styled.section``;
//
// export const MyEventWrap = styled.div`
//   table {
//     border-spacing: 0;
//     width: 100%;
//     border: 1px solid #004ea3;
//     border-radius: 8px;
//     border-bottom-right-radius: 0px;
//     thead {
//       border-radius: 8px;
//       th {
//         border-bottom: 1px solid #004ea3;
//       }
//       tr {
//         th {
//           :first-child {
//             border-top-left-radius: 8px;
//           }
//           :last-child {
//             border-top-right-radius: 8px;
//           }
//         }
//       }
//     }
//     tbody {
//       td {
//         border-bottom: 1px solid #004ea3;
//
//         text-align: center;
//       }
//       tr:last-child {
//         td {
//           :first-child {
//             border-bottom-left-radius: 8px;
//           }
//           :last-child {
//             border-bottom-right-radius: 8px;
//           }
//         }
//       }
//     }
//     tr {
//       background-color: var(--color-gray);
//       border-radius: 8px;
//       :last-child {
//         td {
//           border-bottom: 0;
//         }
//       }
//     }
//
//     th,
//     td {
//       margin: 0;
//       padding: 16px 64px 16px 24px;
//       border-right: 1px solid #004ea3;
//       :last-child {
//         border-right: 0;
//       }
//     }
//   }
//
//   @media only screen and (max-width: 1249px) {
//     table {
//       th,
//       td {
//         padding: 10px;
//     }
//   }
// `;
//
// export const ViewWrap = styled.div`
//   display: flex;
//   flex-direction: column;
//   gap: 16px;
//   .list {
//     display: flex;
//     flex-direction: column;
//     gap: 10px;
//   }
//   .list-name {
//     display: flex;
//     align-items: center;
//     gap: 10px;
//     a {
//       font-size: 14px;
//       font-weight: 400;
//       line-height: 20px;
//       color: #107c41;
//       font-family: "Saira Semi Condensed", sans-serif;
//       cursor: pointer;
//     }
//   }
// `;
//
//
//
// export const SelectEvent = styled.div`
//   display: flex;
//   align-items: center;
//
//   button {
//     display: block;
//     padding: 8px 12px;
//     border-bottom: 1px solid #cad2da;
//     font-size: 16px;
//     font-weight: 600;
//     line-height: 24px;
//     font-family: "Saira Semi Condensed", sans-serif;
//     color: #0e1118;
//     transition: all 0.3s linear;
//     cursor: pointer;
//     &.active {
//       border-bottom: 1px solid #004ea3;
//       color: #004ea3;
//     }
//     :hover {
//       border-bottom: 1px solid #004ea3;
//       color: #004ea3;
//     }
//   }
// `;
//
// export const Container = styled.div`
//   padding: 24px 0;
//   @media only screen and (max-width: 768px) {
//     padding: 24px 0px 8px
//   }
// `;
//
// export const FormWrap = styled.form`
//   width: 100%;
//   max-width: 730px;
//   display: flex;
//   align-items: center;
//   justify-content: space-between;
//   gap: 40px;
//   flex-wrap: wrap;
//   @media only screen and (max-width: 1249px) {
//     gap:30px;
//   }
// `;
//
// export const InputBlock = styled.div`
//   display: flex;
//   justify-content: space-between;
//   gap: 40px;
//   flex-wrap: wrap;
//   width: 100%;
//   @media only screen and (max-width: 1249px) {
//     gap:30px;
//   }
// `;
//
// export const BtnWrap = styled.div`
//   button[type="submit"] {
//     background-color: #004ea3;
//     color: #fff;
//     font-size: 20px;
//     font-weight: 600;
//     line-height: 30px;
//     border-radius: 4px;
//     padding: 13px 32px;
//     border: none;
//     cursor: pointer;
//     transition: all 0.3s linear;
//     :hover {
//       opacity: .9;
//     }
//   }
//   @media only screen and (max-width: 1023px) {
//     button[type="submit"] {
//       padding: 13px 23px;
//       font-size: 16px;
//     }
//   }
// `;
//
// export const InputContainer = styled.div`
//   max-width: 345px;
//   width: 100%;
//   position: relative;
//   font-family: "Saira Semi Condensed", sans-serif;
//   label {
//     display: block;
//     font-weight: 400;
//     font-size: 18px;
//     line-height: 27px;
//     margin-bottom: 4px;
//   }
//   h6 {
//     font-size: 18px;
//     line-height: 27px;
//     font-weight: 400;
//     margin-bottom: 12px;
//   }
//   .event-file {
//     display: flex;
//     align-items: center;
//     gap: 20px;
//
//     a,span {
//       font-size: 14px;
//       font-weight: 400;
//       line-height: 20px;
//       color: #107c41;
//       font-family: "Saira Semi Condensed", sans-serif;
//       cursor: pointer;
//     }
//   }
//   .event-info {
//     a,span {
//       color: #004ea3;
//       text-decoration: underline;
//       cursor: pointer;
//     }
//   }
//   @media only screen and (max-width: 768px) {
//     margin-bottom: 8px;
//   }
// `;
//
// export const InputWrap = styled.input`
//   outline: ${(props) => (props.error ? "1px solid red" : "1px solid #AFB4B9")};
//   width: 100%;
//   height: 42px;
//   color: #0e1118;
//   background-color: transparent;
//   border-radius: 4px;
//   padding: 11px 9px 11px 16px;
//   border: none;
//   font-size: 14px;
//   font-style: normal;
//   font-weight: 400;
//   line-height: 20px;
//   ::placeholder {
//     font-weight: 400;
//     font-size: 14px;
//     line-height: 24px;
//   }
//   input:invalid + span::after {
//     content: "✖";
//     max-width: 200px;
//     padding-left: 5px;
//   }
//
//   input:valid + span::after {
//     content: "✓";
//     max-width: 200px;
//     padding-left: 5px;
//   }
// `;
//
// export const ErrorMessage = styled.div`
//   color: red;
//   opacity: ${(props) => (props.visible ? "1" : "0")};
//   position: absolute;
//   top: 110%;
// `;
//
// export const ErrorWrap = styled.div`
//   position: relative;
//   div {
//     position: inherit;
//     text-align: center;
//     margin-bottom: 5px;
//   }
// `;
//
// export const GenerateEventBlock = styled.div`
//   position: relative;
//
//   .generate {
//     position: absolute;
//     top: 8px;
//     right: 11px;
//     color: #004ea3;
//     text-align: center;
//     font-size: 16px;
//     font-style: normal;
//     font-weight: 500;
//     line-height: 24px;
//     text-decoration-line: underline;
//     cursor: pointer;
//   }
//   .icon {
//     position: absolute;
//     top: 8px;
//     left: 11px;
//   }
//   & .event-id {
//     padding-left: 35px;
//     &::placeholder {
//     }
//   }
// `;
//
// export const ActionWrap = styled.div`
//   display: flex;
//   align-items: center;
//   justify-content: space-between;
//   gap: 4px;
//   img {
//     width: 25px;
//     cursor: pointer;
//   }
//   @media only screen and (max-width: 1249px) {
//     img {
//       width: 18px;
//     }
//   }
// `;
//
// export const BackArrow = styled.div`
//   cursor: pointer;
//   svg path {
//     color: #004ea3;
//   }
//
// `;
//
// export const ViewItem = styled.div`
//   max-width: 400px;
//   width: 100%;
//   display: flex;
//   align-items: center;
//   justify-content: space-between;
//   p {
//     max-width: 200px;
//     width: 100%;
//     text-align: left;
//   }
//   p:has(span) {
//     display: flex;
//     align-items: center;
//     gap: 5px;
//   }
//   div {
//     display: flex;
//     align-items: center;
//
//   }
// `;
//
// export const ChooseSubs = styled.div`
//   display: flex;
//   align-items: center;
//   flex-direction: column;
//   justify-content: center;
//   height: 100%;
//   h2 {
//     font-size: 32px;
//     font-style: normal;
//     font-weight: 400;
//     line-height: 41.6px;
//     margin-bottom: 12px;
//   }
//   button {
//     padding: 12px 32px;
//     background: #004ea3;
//     border-radius: 4px;
//     font-weight: 600;
//     font-size: 20px;
//     line-height: 30px;
//     color: #ffffff;
//     display: block;
//     margin: 0 auto;
//     margin-top: 24px;
//     cursor: pointer;
//   }
//   @media only screen and (max-width: 768px) {
//     padding: 13px;
//     font-size: 16px;
//     line-height: 24px;
//   }
// `;
//
// export const HowImport = styled.div`
//   position: relative;
//   background-color: #fff;
//   border-radius: 10px;
//   background: #fff;
//   padding: 0 48px;
//   .modal-body {
//     padding-top: 60px;
//     max-width: 900px;
//     width: 100%;
//     text-align: center;
//   }
//   .modal-info {
//     max-width: 700px;
//     margin: 0 auto;
//     width: 100%;
//   }
//   .excel {
//     img {
//       max-width: 900px;
//       width: 100%;
//       display: block;
//       object-fit: cover;
//       height: auto;
//     }
//   }
//   .close {
//     position: absolute;
//     top: 2%;
//     right: 3%;
//     cursor: pointer;
//     img {
//       width: 100%;
//       max-width: 40px;
//       height: auto;
//       display: block;
//       object-fit: cover;
//     }
//   }
//   h4 {
//     color: #0e1118;
//     text-align: center;
//     font-size: 38px;
//     font-style: normal;
//     font-weight: 400;
//     line-height: normal;
//   }
//   p {
//     color: rgba(14, 17, 24, 0.8);
//     text-align: center;
//     font-size: 20px;
//     font-style: normal;
//     font-weight: 400;
//     line-height: 28px;
//   }
//   @media only screen and (max-width: 768px) {
//     padding: 0 12px;
//   }
//   @media ${device.tablet} {
//     .modal-body {
//       padding-top: 45px;
//       .modal-info {
//         h4 {
//           font-size: 32px;
//           margin-bottom: 12px;
//         }
//       }
//     }
//   }
//   @media ${device.mobileL}{
//     .modal-body {
//       padding-top: 45px;
//       .modal-info {
//         h4 {
//           font-size: 30px;
//           line-height: 40px;
//           margin-bottom: 12px;
//         }
//         p {
//           font-size: 18px;
//         }
//       }
//     }
//     .close {
//       max-width: 30px;
//     }
//   }
//   @media ${device.mobileM} {
//     .modal-body {
//       padding-top: 45px;
//       .modal-info {
//         h4 {
//           font-size: 26px;
//           line-height: 32px;
//           margin-bottom: 12px;
//         }
//         p {
//           font-size: 18px;
//           margin-bottom: 12px;
//         }
//       }
//     }
//     .close {
//       max-width: 30px;
//     }
//   }
//   @media ${device.mobileS} {
//     .modal-body {
//       padding-top: 45px;
//       .modal-info{
//         h4{
//           font-size: 26px;
//           line-height: 32px;
//         }
//         p {
//           font-size: 18px;
//         }
//       }
//     }
//     .close {
//         max-width: 30px;
//     }
//   }
// `;